import React, { useContext, useState, useEffect } from "react";
import { css } from "emotion";
import BillingTitle from "../billing/BillingTitle";
import { useParams } from "react-router-dom";
import { colors, textSizes, boxStyles } from "../../styles/theme";
import { lighten } from "polished";
import { GlobalContext } from "../../context/GlobalState";
import plans from "../plans/data/plans";
import workspaces from "../../services/api/workspaces";

const PurchaseOverview = () => {
  const { currentWorkspace } = useContext(GlobalContext);
  const { planId: desiredPlan } = useParams();
  const { name, price } = plans.filter((plan) => plan.id === desiredPlan)[0];
  const [charge, setCharge] = useState(0);
  const [refund, setRefund] = useState(0);
  const [total, setTotal] = useState(0);
  const [endDate, setEndDate] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [amountAfterDiscount, setAmountAfterDiscount] = useState(null);

  const getProratedAmt = async () => {
    let prorateData = {
      workspaceId: currentWorkspace.id,
      planId: desiredPlan,
    };
    const coupon = sessionStorage.getItem('coupon');

    if (coupon) {
      prorateData.coupon = coupon;
    }

    try {
      const { data } = await workspaces.prorationCheckout(prorateData);
      const {
        prorationRefund,
        prorationCharge,
        prorationTotal,
        planEndDate,
        discount,
        amountAfterDiscount,
      } = data;
      setCharge(prorationCharge);
      setRefund(prorationRefund);
      setTotal(prorationTotal);
      setEndDate(planEndDate);
      setDiscount(discount);
      setAmountAfterDiscount(amountAfterDiscount);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProratedAmt();
  }, []);

  const formatNumber = (x) => Math.abs(Number.parseFloat(x / 100)).toFixed(2);

  const dateRange = () => {
    const today = new Date();
    const endBillingDate = new Date(0);
    endBillingDate.setUTCSeconds(endDate);

    let endDateString = "";
    if (endDate) {
      endDateString = `
    ${
      endBillingDate.getMonth() + 1
    }/${endBillingDate.getDate()}/${endBillingDate.getFullYear()}
    `;
    }

    return `${
      today.getMonth() + 1
    }/${today.getDate()}/${today.getFullYear()} - ${endDateString}`;
  };

  return (
    <div className={container}>
      <BillingTitle title="Purchase Overview" />
      <div className="price-row">
        <p>Monthly Plan - {name[0].toUpperCase() + name.slice(1)}</p>
        <p>${formatNumber(charge)}</p>
      </div>
      {discount && (
        <div className="price-row">
          <p>{discount.name} ({discount.id})</p>
          <p>-${formatNumber(charge * (discount.percent_off / 100))}</p>
        </div>
      )}
      {10 > 0 && (
        <div className="price-row">
          <p>Minus Prorated ({dateRange()})</p>
          <p>-${formatNumber(refund)}</p>
        </div>
      )}
      <div className="divider" />
      <div className="price-row">
        <p className="total-text">Total Owed Today</p>
        <p>
          {total < 0 && "-"}${formatNumber(amountAfterDiscount || total)}
        </p>
      </div>
      <div className="info-box">
        <p>
          You'll be {total > 0 ? "charged" : "refunded"} a prorated amount of $
          {formatNumber(amountAfterDiscount || total)} today
        </p>
        <p>and charged ${discount ? (price * (discount.percent_off / 100)).toFixed(2) : price} /month going forward.</p>
      </div>
    </div>
  );
};

export default PurchaseOverview;

const container = css`
  padding: ${boxStyles.standardPadding} 0;
  .price-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    p {
      font-size: ${textSizes.normal};
      color: ${colors.subtitleColor};
      font-weight: bold;
    }
    .total-text {
      font-weight: bold;
      color: ${colors.titleColor};
    }
  }

  .divider {
    background-color: ${colors.brandColor};
    height: 1px;
  }

  .info-box {
    background-color: ${lighten(0.3, colors.brandColor)};
    border-radius: ${boxStyles.borderRadius};
    margin: 8px 0;
    padding: 8px;
    text-align: center;
    p {
      font-size: ${textSizes.normal};
      padding: 2px 0;
    }
  }
`;
